'use client';

import { ReactNode } from 'react';
import { PlanContextFragment } from '@/common/__generated__/graphql';
import PlanContext from '@/context/plan';
type Props = {
  plan: PlanContextFragment;
  children: ReactNode;
};
export default function PlanProvider({
  plan,
  children
}: Props) {
  return <PlanContext.Provider value={plan} data-sentry-element="PlanContext.Provider" data-sentry-component="PlanProvider" data-sentry-source-file="PlanProvider.tsx">{children}</PlanContext.Provider>;
}